import React, { useEffect, useState } from 'react';
import DataTableMD from '../core/dataTableMD';
import { getOnCallColumns, getOnCallFilters } from './configs/onCallDataTableConfig';

/**
 * On-Call Schedules page (FEAT-051). Lists a school's rotations with the current on-call
 * responder (enriched server-side) and an "Add rotation" modal. Admin tiers only (nav + backend
 * both gate it); server-side scoping keeps a school/district admin to their own scope.
 */
const OnCallSchedulesPage = () => {
  const [columns, setColumns] = useState([]);
  const [filters, setFilters] = useState([]);

  useEffect(() => {
    const load = async () => {
      setColumns(await getOnCallColumns());
      setFilters(await getOnCallFilters());
    };
    load();
  }, []);

  const addSuccessMessage = "The on-call rotation has been created.";
  return (
    <DataTableMD
      title="On-Call"
      dbTable={"oncallschedules"}
      filters={filters}
      columns={columns}
      addButton={true}
      addSuccessMessage={addSuccessMessage}
      sort={{ field: 'name', order: 'asc' }}
    />
  );
};

export default OnCallSchedulesPage;
